import { hyphenate as hyphenEn } from 'hyphen/en'
import { hyphenate as hyphenIs } from 'hyphen/is'

const HyphenateText = {
  init(target) {
    const str = target.innerHTML
    const { lang } = document.documentElement

    const hyphenate = lang === 'is' ? hyphenIs : hyphenEn

    if (!str) {
      return
    }

    hyphenate(str).then((res: string) => {
      target.innerHTML = res
    })
  },
}

export default HyphenateText
